
import {Component, Vue} from 'vue-property-decorator';
import {dispatchDeleteForm, dispatchGetFormsAdmin} from '@/store/admin/actions';
import {readAdminForms} from '@/store/admin/getters';
import DynamicTable from '@/components/datatables/DynamicTable.vue';

@Component({
  components: {DynamicTable},
})
export default class FormList extends Vue {

  public headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-forms-edit', width: '100px', delete_function: this.deleteForm},
    {text: this.$t('title'), sortable: true, value: 'title', align: 'left'},
    {text: this.$t('created_by_user'), sortable: false, value: 'created_by_user', align: 'left', type: 'user_object'},
    {text: this.$t('updated_by_user'), sortable: false, value: 'updated_by_user', align: 'left', type: 'user_object'},
    {text: this.$t('version'), sortable: true, value: 'version', align: 'right'},
    {text: `${this.$t('form_is_enabled')}?`, sortable: true, value: 'is_enabled', align: 'center'},
    {text: this.$t('preview'), sortable: false, value: 'form_preview', align: 'left'},
  ];

  get forms() {
    return readAdminForms(this.$store);
  }

  public async mounted() {
    // location.reload();
    await dispatchGetFormsAdmin(this.$store);
  }

  public async deleteForm(id) {
    await dispatchDeleteForm(this.$store, id);
    await dispatchGetFormsAdmin(this.$store);
  }

}
